import React from 'react';
import { ClearRefinementsConnectorParams } from 'instantsearch.js/es/connectors/clear-refinements/connectClearRefinements';
import { useClearRefinements } from 'react-instantsearch';
import { useEventListContext } from '../context/EventListProvider';

const FilterButtons = (props: ClearRefinementsConnectorParams) => {
  const { i18n, closeDialog } = useEventListContext();
  const { canRefine, refine } = useClearRefinements(props);

  if (!canRefine) return null;

  return (
    <div className="event-list__filter-buttons">
      <button
        className="button button--primary"
        type="button"
        onClick={closeDialog}
      >
        <span className="typo-button">{i18n.applyFilter}</span>
      </button>

      <button
        className="button button--secondary"
        type="button"
        onClick={refine}
      >
        <span className="typo-button">{i18n.clearFilter}</span>
      </button>
    </div>
  );
};

export default FilterButtons;
